const PAYMENT_MOBILE_CODES = new Set([
  "PRW-PAGO-MOVIL",
  "PRW-PAYMENT-MOBILE",
]);

export const isPaymentMobileCode = (methodCode: string): boolean => {
  return PAYMENT_MOBILE_CODES.has(methodCode.trim().toUpperCase());
};
